/* External Imports */
import { Box, Flex, Link } from '@chakra-ui/react';
import LazyLoadImageComponent from '@components/UI/LazyLoadImageComponent';

/* Internal Imports */
/* Components */
import StructuredTextContent from '@components/UI/StructuredTextContent';
import config from '@config';
import { refineUrlDomain } from '@components/Utility/utils';

/**
 * @description Renders the Yantra Table Module component
 * @param {Object} tableData - data
 * @returns {ReactElement} YantraTableModule component
 */

const YantraTableModule = ({ tableData, sectionid }) => {
  let newObj = '';
  if (tableData.length > 0) {
    newObj = Object.values(tableData[0]?.data[0]);
  }
  return (
    <>
      {tableData.length > 0 && (
        <>
          <Box bgColor="#FFF7E2" className="tablemodule" id={sectionid}>
            <Box maxWidth="850px" m="0 auto">
              <Flex
                width={{ lg: '100%', md: '95%', sm: '90%' }}
                m="0 auto"
                alignItems="center"
                display={{ base: 'none', md: 'flex' }}
              >
                {tableData[0]?.data?.map((tdata, i) => {
                  return (
                    <Box
                      justifyContent="center"
                      fontSize={{ base: '14px', lg: '16px' }}
                      className="onlinedetail"
                      width="100%"
                      lineHeight="16px"
                      key={i}
                    >
                      <Box
                        bgColor={i == 0 ? '#FFF7E2' : '#EEE2C3'}
                        borderBottom="1px solid #EEE2C3"
                        p="8px 40px"
                        h="44px"
                        fontSize={{ base: '14px', lg: '16px' }}
                        display="table"
                        width="100%"
                        color="#483C1B"
                        borderRadius={
                          i > 0 && i == 1 ? '20px 0 0 0' : '0 20px  0 0'
                        }
                        textAlign={i == 0 ? 'left' : 'center'}
                        whiteSpace="nowrap"
                        position="relative"
                        key={tdata.Title}
                      >
                        <Box
                          as="span"
                          display="table-cell"
                          verticalAlign="middle"
                        >
                          {i == 1 && (
                            <Box
                              borderRight="1px solid #9C9174"
                              position="absolute"
                              right="0"
                              height="40%"
                              top="14px"
                            ></Box>
                          )}
                          {tdata.Title}
                        </Box>
                      </Box>
                      <Box
                        p={{ base: '10px 30px' }}
                        h="65px"
                        display="table"
                        width="100%"
                        background="#fff"
                        color={i == 0 ? '#818181' : '#222'}
                        fontFamily={
                          i > 0 ? 'FedraSansStd-Medium' : 'FedraSerifAStdBook'
                        }
                        textAlign={i == 0 ? 'left' : 'center'}
                        borderLeft={i == 0 ? 'solid 1px #EEE2C3' : ''}
                        borderRight={i == 2 ? 'solid 1px #EEE2C3' : ''}
                        key={tdata.ProgramFee}
                      >
                        <Box
                          as="span"
                          display="table-cell"
                          verticalAlign="middle"
                        >
                          {tdata.ProgramFee}
                        </Box>
                      </Box>
                      <Box
                        p={{ base: '10px 30px' }}
                        h="65px"
                        display="table"
                        color={i == 0 ? '#818181' : '#222'}
                        width="100%"
                        background="#fff"
                        textAlign={i == 0 ? 'left' : 'center'}
                        borderLeft={i == 0 ? 'solid 1px #EEE2C3' : ''}
                        borderRight={i == 2 ? 'solid 1px #EEE2C3' : ''}
                        key={tdata.Stay}
                      >
                        <Box
                          as="span"
                          display="table-cell"
                          verticalAlign="middle"
                        >
                          {tdata.Stay}
                        </Box>
                      </Box>
                      <Box
                        p={{ base: '8px 30px' }}
                        h="65px"
                        display="table"
                        width="100%"
                        background="#fff"
                        color="#818181"
                        textAlign={i == 0 ? 'left' : 'center'}
                        whiteSpace="nowrap"
                        borderLeft={i == 0 ? 'solid 1px #EEE2C3' : ''}
                        borderRight={i == 2 ? 'solid 1px #EEE2C3' : ''}
                        key={tdata.Learn}
                      >
                        <Box
                          as="span"
                          display="table-cell"
                          verticalAlign="middle"
                        >
                          {i == 0 ? (
                            <> {tdata.Learn}</>
                          ) : (
                            <>
                              {tdata.Learn == '[yes]' ? (
                                <LazyLoadImageComponent
                                  src={`${config.staticPath}/d/46272/1637214105-greentick.png`}
                                  alt="green check"
                                  title="green check"
                                />
                              ) : (
                                // <Image src="https://images.sadhguru.org/d/46272/1637214105-greentick.png" />
                                <> - </>
                              )}
                            </>
                          )}
                        </Box>
                      </Box>
                      <Box
                        borderBottom="1px solid #EEE2C3"
                        p={{ base: '8px 30px' }}
                        h="65px"
                        display="table"
                        width="100%"
                        color="#818181"
                        textAlign={i == 0 ? 'left' : 'center'}
                        background="#fff"
                        whiteSpace="nowrap"
                        borderLeft={i == 0 ? 'solid 1px #EEE2C3' : ''}
                        borderRight={i == 2 ? 'solid 1px #EEE2C3' : ''}
                      >
                        <Box
                          as="span"
                          display="table-cell"
                          verticalAlign="middle"
                        >
                          {i == 0 ? (
                            <> {tdata.Seating}</>
                          ) : (
                            <>
                              {tdata.Seating == '[yes]' ? (
                                <LazyLoadImageComponent
                                  alt="green check"
                                  title="green check"
                                  src={`${config.staticPath}/d/46272/1637214105-greentick.png`}
                                />
                              ) : (
                                // <Image src="https://images.sadhguru.org/d/46272/1637214105-greentick.png" />
                                <> - </>
                              )}
                            </>
                          )}
                        </Box>
                      </Box>
                    </Box>
                  );
                })}
              </Flex>
              <Box
                bgColor="#fff"
                borderBottom="solid 1px #EEE2C3"
                p={{ base: '40px 20px 10px', md: '30px' }}
                display={{ base: 'block', md: 'none' }}
              >
                {tableData[0]?.data.slice(1)?.map((columnVal, count) => {
                  let tabelValues = Object.values(columnVal);
                  return (
                    <Box
                      border="solid 1px #EEE2C3"
                      mb="30px"
                      borderRadius="15px"
                      overflow="hidden"
                      key={count}
                    >
                      {newObj.map((tableTitle, i) => {
                        return (
                          <Box key={i}>
                            {i == 0 ? (
                              <Box
                                bgColor="#EEE2C3"
                                color="#483C1B"
                                fontSize="16px"
                                p="16px 20px"
                              >
                                {tabelValues[i]}
                              </Box>
                            ) : (
                              <Box
                                bgColor="#fff"
                                padding="20px"
                                display="flex"
                                justifyContent="space-between"
                              >
                                <Box color="#818181" width="50%">
                                  {tableTitle}
                                </Box>
                                <Box
                                  fontFamily={
                                    i == 1
                                      ? 'FedraSansStd-Medium'
                                      : 'FedraSerifAStdBook'
                                  }
                                >
                                  {i > 2 ? (
                                    <>
                                      {tabelValues[i] == '[yes]' ? (
                                        <LazyLoadImageComponent
                                          src={`${config.staticPath}/d/46272/1637214105-greentick.png`}
                                        />
                                      ) : (
                                        // <Image src="https://images.sadhguru.org/d/46272/1637214105-greentick.png" />
                                        <> - </>
                                      )}
                                    </>
                                  ) : (
                                    <> {tabelValues[i]}</>
                                  )}
                                </Box>
                              </Box>
                            )}
                          </Box>
                        );
                      })}
                    </Box>
                  );
                })}
              </Box>

              <Box
                fontStyle="italic"
                fontSize="16px"
                fontFamily="FedraSansStd-book"
                mt="18px"
                color="#000"
                px={{ base: '20px', lg: '0' }}
              >
                {StructuredTextContent(tableData[1]?.body)}
              </Box>
            </Box>
            <style jsx global>
              {`
                .tablemodule a {
                  color: #5e1518;
                  text-decoration: underline;
                  font-weight: bold;
                }
              `}
            </style>
          </Box>
        </>
      )}
    </>
  );
};

export default YantraTableModule;
